function openCartDrawer() {
    document.querySelector(".cart-drawer")?.classList.add("cart-drawer--active");
}

function closeCartDrawer() {
    document.querySelector(".cart-drawer")?.classList.remove("cart-drawer--active");
}

// --- quantity update state (optimistic UI + debounce) ---
const cartQtyPending = {};
const cartQtyTimers = {};

function renderCartDrawerHtml(text) {
    const html = document.createElement("div");
    html.innerHTML = text;
    const newDrawer = html.querySelector(".cart-drawer");
    if (!newDrawer) return false;
    document.querySelector(".cart-drawer").innerHTML = newDrawer.innerHTML;
    addCartDrawerListeners();
    return true;
}

async function updateCartDrawer() {
    const res = await fetch("/?section_id=cart-drawer-umang");
    const text = await res.text();
    renderCartDrawerHtml(text);
}

// Send ONE combined request (update + re-rendered section) after the user stops clicking.
async function syncCartQty(key) {
    const newQty = cartQtyPending[key];
    try {
        const res = await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
                updates: { [key]: newQty },
                sections: ["cart-drawer-umang"],
                sections_url: window.location.pathname,
            }),
        });
        const data = await res.json().catch(() => null);
        delete cartQtyPending[key];
        const sectionHtml = data && data.sections && data.sections["cart-drawer-umang"];
        if (!sectionHtml || !renderCartDrawerHtml(sectionHtml)) {
            await updateCartDrawer(); // fallback
        }
    } catch (e) {
        delete cartQtyPending[key];
        await updateCartDrawer(); // fallback on error
    }
}

function addCartDrawerListeners() {
    // Quantity +/- buttons (optimistic instant update + debounced single sync)
    document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
        button.addEventListener("click", () => {
            const rootItem = button.closest("[data-line-item-key]");
            const key = rootItem.getAttribute("data-line-item-key");
            const input = button.parentElement.querySelector("input");
            const base = key in cartQtyPending ? cartQtyPending[key] : Number(input.value);
            const isIncrease = button.classList.contains("cart-drawer-quantity-selector-plus");
            const newQty = isIncrease ? base + 1 : Math.max(base - 1, 0);

            cartQtyPending[key] = newQty;
            input.value = newQty; // optimistic: the number updates instantly

            clearTimeout(cartQtyTimers[key]);
            cartQtyTimers[key] = setTimeout(() => syncCartQty(key), 350);
        });
    });
    document.querySelectorAll(".cart-drawer-remove-button").forEach((button) => {
        button.addEventListener("click", async () => {
            const key = button.getAttribute("data-line-item-key");

            await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({ updates: { [key]: 0 } }),
            });

            updateCartDrawer();
        });
    });

    // Prevent drawer close on box click
    document.querySelector(".cart-drawer-box")?.addEventListener("click", (e) => e.stopPropagation());

    // Close drawer on outside click or close button
    document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer").forEach((el) => el.addEventListener("click", closeCartDrawer));
}

document.addEventListener("DOMContentLoaded", () => {
    function applySwatchAndCartBehavior(scope = document) {
        const products = document.querySelectorAll('.card-product-form');
        scope.querySelectorAll(".add-to-cart-custom").forEach((btn) => {
           btn.addEventListener("click", async (event) => {
                event.preventDefault();
                event.stopPropagation();
                if (btn.classList.contains("select-a-variant")) {
                    // Your logic if it HAS the class
                    console.log("Button has class .select-a-variant");
                    event.preventDefault();
                    event.stopPropagation();
                    const id_p = btn.getAttribute("data-product-id");
                    const wrapper = document.getElementById(`card-product-form-${id_p}`);
                    const TitleElement = wrapper?.querySelector('.card-product-prices');
                    if (TitleElement) {
                        if (!wrapper.querySelector('.select-warning')) {
                            const message = document.createElement('div');
                            message.className = 'select-warning';
                            message.style.color = 'red';
                            message.style.marginBottom = '10px';
                            message.textContent = 'אנא בחר סוג מוצר';
                            wrapper.prepend(message);
                        }
                    }
                    return; // Optional: to stop further execution
                }

                const textSpan = btn.querySelector('.add-to-cart-text');
                const container = btn.closest(".card-product-form"); // adjust selector as needed
                const variantId = parseInt(container.querySelector(".product-variant-id").value);
                // Then find the input inside that container
                const qtyInput = container.querySelector(".quantity-input");
                console.log("qtyInput",qtyInput);
                const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

                const spinner = btn.querySelector('.spinner');
                btn.disabled = true;
                textSpan.style.display = 'none';
                spinner.style.display = 'inline-block';
                btn.classList.add("loading");

                if (btn.dataset.bound === "true") return; // optional safety
                btn.dataset.bound = "true";
                console.log(": ADD TO CART REQUEST CALL :");
                await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify({ id: variantId, quantity: qty }),
                });
                console.log(" in 436", qty);
                
                await updateCartDrawer();
                openCartDrawer();
                btn.disabled = false;
                spinner.style.display = 'none';
                textSpan.style.display = 'inline';
                btn.classList.remove("loading");
                btn.dataset.bound = "false";

            });
        });
        products.forEach(product => {
            const priceDiv = product.querySelector(".card-product-prices");
            const unitDiv = product.querySelector(".price-item");
            const warnDiv = product.querySelector(".select-warning");
            const swatches = product.querySelectorAll('.variant-swatch');
            const priceElement = product.querySelector('.v-price');
            const compareAtPriceElement = product.querySelector('.v-compare-at-price');
            const addToCartButton = product.querySelector('.add-to-cart-custom');
            const pricePerUnitDiv = product.querySelector(".price-per-unit");
            let Vselector = product.querySelector('.product-variant-id');
            let selectedVariantPrice = priceElement?.textContent;
            let selectedCompareAtPrice = compareAtPriceElement?.textContent;
            let selectedVariantId = swatches.length > 0 ? product.querySelector('.variant-swatch.selected')?.getAttribute('data-variant-id') : product.querySelector('.product-variant-id').value;
            let firstRemoved = false;
            const selectDrop = product.querySelector(".v-ids");
            if (selectDrop) {
                selectDrop.addEventListener("change", function () {
                    if (!firstRemoved && selectDrop.options.length > 0) {
                        selectDrop.remove(0);
                        firstRemoved = true;
                    }
                    if (product.querySelector(".select-warning")) {
                        product.querySelector(".select-warning").remove();
                    }
                    var selectedOption = selectDrop.options[selectDrop.selectedIndex];
                    var vid = selectedOption.getAttribute("data-variant-id");
                    console.log("Variant ID:", vid);
                    const matchingSwatch = product.querySelector(`.variant-swatch[data-variant-id="${vid}"]`);
                    if (matchingSwatch) {
                        matchingSwatch.click(); // Trigger the click to reuse the swatch logic
                    }
                });
            }

            if (swatches.length > 0) {
                swatches.forEach(swatch => {
                    swatch.addEventListener('click', function () {
                        const variantId = swatch.getAttribute('data-variant-id');
                        const variantPrice = swatch.getAttribute('data-price');
                        const variantCompareAtPrice = swatch.getAttribute('data-compare-at-price');
                        const variantUnitPrice = swatch.getAttribute("data-unitprice");

                        if (addToCartButton.classList.contains('select-a-variant')) {
                            addToCartButton.classList.remove('select-a-variant');
                        }
                        if (priceDiv) {
                            priceDiv.style.display = "inline";
                        }

                        if (warnDiv) {
                            warnDiv.remove();
                        }

                        if (unitDiv) {
                            unitDiv.style.display = "inline";
                        }


                        swatches.forEach(s => s.classList.remove('selected'));
                        swatch.classList.add('selected');

                        if (priceElement) priceElement.textContent = variantPrice;

                        if (compareAtPriceElement) {
                            if (variantCompareAtPrice && variantCompareAtPrice !== '$0.00') {
                                compareAtPriceElement.style.display = 'block';
                                compareAtPriceElement.textContent = variantCompareAtPrice;
                            } else {
                                compareAtPriceElement.style.display = 'none';
                            }
                        }

                        if (pricePerUnitDiv) {
                            if (variantUnitPrice && variantUnitPrice !== "0") {
                                pricePerUnitDiv.innerHTML = variantUnitPrice;
                                pricePerUnitDiv.innerHTML = pricePerUnitDiv.innerHTML.replace(/<br\s*\/?>/gi, '');
                            }
                        }

                        selectedVariantId = variantId;
                        selectedVariantPrice = variantPrice;
                        selectedCompareAtPrice = variantCompareAtPrice;
                        Vselector.value = selectedVariantId;
                    });
                });
            }
        });
    }

    addCartDrawerListeners();



    // Observe when product recommendations load
    const recommendationsWrapper = document.querySelector('.related-products');
    if (recommendationsWrapper) {

        const observer = new MutationObserver((mutationsList) => {

            for (const mutation of mutationsList) {
                console.log("mutation", mutation);

                if (
                    mutation.type === 'childList' &&
                    mutation.target.classList.contains('related-products') &&
                    mutation.target.childElementCount > 0
                    && mutation.target.firstElementChild?.classList.contains('related-complementary')
                ) {
                    console.log("hiii2", mutation);
                    applySwatchAndCartBehavior(mutation.target);
                }
                if (
                    mutation.type === 'childList' &&
                    mutation.target.classList.contains('related-products') &&
                    mutation.target.childElementCount > 0
                ) {
                    console.log("hiii11", mutation);
                    applySwatchAndCartBehavior(mutation.target);
                }

            }

        });

        observer.observe(recommendationsWrapper, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
        });

        if (document.querySelector('.card-product-form')) {
            applySwatchAndCartBehavior();
        }

    } else {
        // Add to cart
        document.querySelectorAll(".add-to-cart-custom").forEach((btn) => {
            btn.addEventListener("click", async (event) => {
                                    event.preventDefault();
                    event.stopPropagation();

                if (btn.classList.contains("select-a-variant")) {
                    // Your logic if it HAS the class
                    event.preventDefault();
                    event.stopPropagation();
                    const id_p = btn.getAttribute("data-product-id");
                    const wrapper = document.getElementById(`card-product-form-${id_p}`);
                    const TitleElement = wrapper?.querySelector('.card-product-prices');
                    if (TitleElement) {
                        if (!wrapper.querySelector('.select-warning')) {
                            const message = document.createElement('div');
                            message.className = 'select-warning';
                            message.style.color = 'red';
                            message.style.marginBottom = '10px';
                            message.textContent = 'אנא בחר סוג מוצר';
                            wrapper.prepend(message);

                            // TitleElement.parentNode.insertBefore(message, TitleElement); 
                        }
                    }


                    return; // Optional: to stop further execution
                }

                const container = btn.closest(".card-product-form"); // adjust selector as needed
                const variantId = parseInt(container.querySelector(".product-variant-id").value);
                // Then find the input inside that container
                const qtyInput = container.querySelector(".quantity-input");
                const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
                const textSpan = btn.querySelector('.add-to-cart-text');
                const spinner = btn.querySelector('.spinner');
                btn.disabled = true;
                textSpan.style.display = 'none';
                spinner.style.display = 'inline-block';
                btn.classList.add("loading");
                console.log("vid", variantId);

                console.log(document.querySelector("#nav-cart-item-value").innerHTML, qty);

                if (btn.dataset.bound === "true") return; // optional safety
                btn.dataset.bound = "true";
                await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify({ id: variantId, quantity: qty }),
                });
                console.log(" in 634", qty);
                await updateCartDrawer();
                openCartDrawer();
                btn.disabled = false;
                spinner.style.display = 'none';
                textSpan.style.display = 'inline';
                btn.classList.remove("loading");
                btn.dataset.bound = "false";

            });
        });
        let products = document.querySelectorAll('.card-product-form');

        products.forEach(product => {
            const swatches = product.querySelectorAll('.variant-swatch');
            const priceElement = product.querySelector('.v-price');
            const compareAtPriceElement = product.querySelector('.v-compare-at-price');
            const addToCartButton = product.querySelector('.add-to-cart-custom');
            const pricePerUnitDiv = product.querySelector(".price-per-unit");
            const warnDiv = product.querySelector(".select-warning");
            const priceDiv = product.querySelector(".card-product-prices");
            const unitDiv = product.querySelector(".price-item");

            let selectedVariantPrice = priceElement?.textContent;
            let selectedCompareAtPrice = compareAtPriceElement?.textContent;
            let Vselector = product.querySelector('.product-variant-id');

            let selectedVariantId = swatches.length > 0 ? product.querySelector('.variant-swatch.selected')?.getAttribute('data-variant-id') : product.querySelector('.product-variant-id').value;
            selectedVariantId = parseInt(selectedVariantId);
            const selectDrop = product.querySelector(".v-ids");
            let firstRemoved = false;

            if (selectDrop) {
                selectDrop.addEventListener("change", function () {
                    if (!firstRemoved && selectDrop.options.length > 0) {
                        selectDrop.remove(0);
                        firstRemoved = true;
                    }
                    if (product.querySelector(".select-warning")) {
                        product.querySelector(".select-warning").remove();
                    }

                    var selectedOption = selectDrop.options[selectDrop.selectedIndex];
                    var vid = selectedOption.getAttribute("data-variant-id");
                    console.log("Variant ID:", vid);
                    const matchingSwatch = product.querySelector(`.variant-swatch[data-variant-id="${vid}"]`);
                    if (matchingSwatch) {
                        matchingSwatch.click(); // Trigger the click to reuse the swatch logic
                    }

                });
            }

            if (swatches.length > 0) {
                swatches.forEach(swatch => {
                    swatch.addEventListener('click', function () {
                        if (addToCartButton.classList.contains('select-a-variant')) {
                            addToCartButton.classList.remove('select-a-variant');
                        }
                        if (priceDiv) {
                            priceDiv.style.display = "inline";
                        }
                        if (warnDiv) {
                            warnDiv.remove();
                        }
                        if (unitDiv) {
                            unitDiv.style.display = "inline";
                        }


                        const variantId = swatch.getAttribute('data-variant-id');
                        const variantPrice = swatch.getAttribute('data-price');
                        const variantCompareAtPrice = swatch.getAttribute('data-compare-at-price');
                        const variantUnitPrice = swatch.getAttribute("data-unitprice");

                        swatches.forEach(s => s.classList.remove('selected'));
                        swatch.classList.add('selected');

                        if (priceElement) priceElement.textContent = variantPrice;

                        if (compareAtPriceElement) {
                            if (variantCompareAtPrice && variantCompareAtPrice !== '$0.00') {
                                compareAtPriceElement.style.display = 'block';
                                compareAtPriceElement.textContent = variantCompareAtPrice;
                            } else {
                                compareAtPriceElement.style.display = 'none';
                            }
                        }

                        if (pricePerUnitDiv) {
                            if (variantUnitPrice && variantUnitPrice !== "0") {
                                pricePerUnitDiv.innerHTML = variantUnitPrice;
                                // Strip any <br> tags or extra whitespace after insertion
                                pricePerUnitDiv.innerHTML = pricePerUnitDiv.innerHTML.replace(/<br\s*\/?>/gi, '');
                            }
                        }

                        selectedVariantId = variantId;
                        selectedVariantPrice = variantPrice;
                        selectedCompareAtPrice = variantCompareAtPrice;
                        Vselector.value = selectedVariantId;
                    });
                });
            }

        });

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && node.matches(".card-product-form")) {
                        applySwatchAndCartBehavior(node);
                    } else if (node.nodeType === 1) {
                        const innerProduct = node.querySelector(".card-product-form");
                        if (innerProduct) {
                            applySwatchAndCartBehavior(innerProduct);
                        }
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    let lastHasClass = false;

    window.addEventListener('scroll', () => {
        const relatedProductsNew = document.querySelector('.related-section-wrapper');
        const hasClass =
            relatedProductsNew?.firstElementChild?.classList.contains('related-complementary') || false;
        if (hasClass && !lastHasClass) {
            console.log('Scrolled and found related-complementary');
            setTimeout(function () {
                applySwatchAndCartBehavior();
            }, 1000);

        }
        lastHasClass = hasClass;
    });

    console.log('huuuuuuScrolled and found related-complementary');
});
